import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getBroadcasts, getMyAccount } from '../../../../api/queries';
import BroadcastsTable from '../../../../components/broadcastsTable';
import H2 from '../../../../components/h2';
import P from '../../../../components/p';
import Spacer from '../../../../components/spacer';
import BroadcastsMenu from '../../../../layouts/broadcastsMenu';
import AppState from '../../../../store/appstate';

function Broadcasts() {
  const { t } = useTranslation('other');
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  // const history = useHistory();

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });

  const broadcasts = getBroadcasts({
    ac: selectedAccount,
    oc: myAccount?.data?.originatorcode?.code,
  });

  useEffect(() => {
    if (selectedAccount) {
      broadcasts.refetch();
    }
  }, [selectedAccount]);

  return (
    <div className="flex flex-wrap">
      <div className="xl:w-80 w-full bg-sentric-menu-gray">
        <BroadcastsMenu />
      </div>
      <div className="flex-1 xl:w-full sentric-shadow-left bg-sentric-content-white lg:p-6 p-4 min-h-50 lg:min-h-screen-minus-header shadow lg:shadow-none order-last">
        <H2>{t('other:your-broadcasts-header')}</H2>
        <Spacer thin />
        <P small>{t('other:your-broadcasts-text')}</P>
        <Spacer />
        <BroadcastsTable />
      </div>
    </div>
  );
}
export default Broadcasts;
